import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

// Words collected from the Back to School themed challenges
// These are the start and target words from all QR code challenges
// Collecting all 23 QR codes unlocks this special collection!
const backToSchoolWordList = [
  "answer",
  "art",
  "beauty",
  "bond",
  "clarity",
  "color",
  "confidence",
  "create",
  "dance",
  "discovery",
  "emotion",
  "encourage",
  "example",
  "fair",
  "focus",
  "guide",
  "harmony",
  "help",
  "investigate",
  "joy",
  "learn",
  "lesson",
  "music",
  "observe",
  "paint",
  "progress",
  "question",
  "read",
  "share",
  "sing",
  "strength",
  "succeed",
  "success",
  "teach",
  "trust",
  "try",
  "understand",
  "unite",
];

export const backToSchoolCollection: WordCollection = createCollection(
  "back-to-school",
  "Back to School",
  backToSchoolWordList,
  {
    icon: "school",
    isWordlistViewable: true,
    // Available during back-to-school season (July - October)
    startDate: new Date(new Date().getFullYear(), 6, 20), // July 20th
    endDate: new Date(new Date().getFullYear(), 9, 31), // October 31st
  },
);
